"use strict";function disable$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.disable$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="ui.pullToRefresh.disable";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.4.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.4.0"},_a)),exports.disable$=disable$,exports.default=disable$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/ui/pullToRefresh/disable.js
// module id = 1098
// module chunks = 106